module.exports = __webpack_public_path__ + "img/9788937832888.b2f4b89f.jpg";